(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial"] && !Shopify.designMode) return;
  try {
    
  const initAdvertorial = (root) => {
    if (root.dataset.advertorialReady === 'true') return;
    root.dataset.advertorialReady = 'true';

    const sticky = root.querySelector('[data-advertorial-sticky]');
    const start = root.querySelector('[data-advertorial-start]');
    if (!sticky || !start || !('IntersectionObserver' in window)) return;

    // Show the sticky CTA once the top of the article has scrolled out of
    // view, hide it again when the reader scrolls back up to the intro.
    const sentinel = document.createElement('div');
    start.prepend(sentinel);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { rootMargin: '300px 0px 0px 0px' }
    );
    observer.observe(sentinel);
  };

  document.querySelectorAll('[data-advertorial]').forEach(initAdvertorial);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-advertorial]').forEach(initAdvertorial);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  // Section javascript blocks are concatenated into a shared scripts.js, so
  // document.currentScript never points inside a section. Initialize every
  // instance on the page instead, with a per-element guard.
  const initBackgroundImageText = (section) => {
    if (section.dataset.bitParallaxReady === 'true') return;
    section.dataset.bitParallaxReady = 'true';

    if (section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  };

  const initAllBackgroundImageText = () => {
    document.querySelectorAll('.background-image-text-section').forEach(initBackgroundImageText);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBackgroundImageText);
  } else {
    initAllBackgroundImageText();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.background-image-text-section');
    if (section) initBackgroundImageText(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Header interactions. This runs once from the bundled scripts.js, so
  // document-level listeners are bound once; element bindings are guarded
  // per element and re-applied on shopify:section:load for the editor.
  const HEADER_FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const closeOtherHeaderDisclosures = (currentDisclosure) => {
    document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
      if (disclosure !== currentDisclosure) {
        disclosure.removeAttribute('open');
      }
    });
  };

  const initHeaderElements = () => {
    document.querySelectorAll('[data-header-disclosure]').forEach((disclosure) => {
      if (disclosure.dataset.headerReady === 'true') return;
      disclosure.dataset.headerReady = 'true';

      disclosure.addEventListener('toggle', () => {
        if (disclosure.open) {
          closeOtherHeaderDisclosures(disclosure);
          document.querySelectorAll('[data-header-search][open]').forEach((search) => {
            search.removeAttribute('open');
          });
        }
      });

      // "Enable dropdown on hover": CSS alone can't reveal the content of a
      // closed <details>, so toggle the open attribute from JS.
      if (disclosure.dataset.hoverEnabled === 'true') {
        let hoverCloseTimer = null;
        disclosure.addEventListener('mouseenter', () => {
          window.clearTimeout(hoverCloseTimer);
          disclosure.setAttribute('open', '');
        });
        disclosure.addEventListener('mouseleave', () => {
          // Small delay so diagonal cursor travel into the submenu doesn't close it.
          hoverCloseTimer = window.setTimeout(() => {
            disclosure.removeAttribute('open');
          }, 150);
        });
      }
    });

    document.querySelectorAll('[data-header-search]').forEach((search) => {
      if (search.dataset.headerReady === 'true') return;
      search.dataset.headerReady = 'true';

      search.addEventListener('toggle', () => {
        if (!search.open) return;

        closeOtherHeaderDisclosures();
        document.querySelectorAll('[data-header-search][open]').forEach((item) => {
          if (item !== search) {
            item.removeAttribute('open');
          }
        });

        const input = search.querySelector('input[type="search"]');
        window.requestAnimationFrame(() => input?.focus());
      });
    });

    document.querySelectorAll('[data-header-drawer]').forEach((drawer) => {
      if (drawer.dataset.headerReady === 'true') return;
      drawer.dataset.headerReady = 'true';

      const toggle = drawer.querySelector('[data-header-drawer-toggle]');
      const panel = drawer.querySelector('[data-header-drawer-panel]');
      const closeButton = drawer.querySelector('[data-header-drawer-close]');
      let lastFocusedElement = null;

      const getFocusableElements = () =>
        [...panel.querySelectorAll(HEADER_FOCUSABLE_SELECTOR)].filter((element) => !element.hasAttribute('hidden'));

      const closeDrawer = () => {
        drawer.removeAttribute('open');
      };

      const handleKeydown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      };

      closeButton?.addEventListener('click', (event) => {
        event.preventDefault();
        closeDrawer();
      });

      drawer.addEventListener('toggle', (event) => {
        if (event.target !== drawer) return;

        if (drawer.open) {
          lastFocusedElement = document.activeElement;
          document.documentElement.classList.add('header-drawer-open');
          document.body.classList.add('header-drawer-open');
          panel.addEventListener('keydown', handleKeydown);
          window.requestAnimationFrame(() => {
            const focusableElements = getFocusableElements();
            (focusableElements[0] || panel).focus();
          });
        } else {
          document.documentElement.classList.remove('header-drawer-open');
          document.body.classList.remove('header-drawer-open');
          panel.removeEventListener('keydown', handleKeydown);
          if (lastFocusedElement instanceof HTMLElement) {
            lastFocusedElement.focus();
          } else {
            toggle?.focus();
          }
        }
      });
    });

    const overlayHeader = document.querySelector('.header--overlay');
    if (overlayHeader && overlayHeader.dataset.overlayReady !== 'true') {
      overlayHeader.dataset.overlayReady = 'true';
      const solidThreshold = 60;
      const updateOverlayState = () => {
        overlayHeader.classList.toggle('is-scrolled', window.scrollY > solidThreshold);
      };
      updateOverlayState();
      window.addEventListener('scroll', updateOverlayState, { passive: true });
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-header-disclosure]')) return;
    document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
      disclosure.removeAttribute('open');
    });
    if (event.target.closest('[data-header-search]')) return;
    document.querySelectorAll('[data-header-search][open]').forEach((search) => {
      search.removeAttribute('open');
    });
    // Close the mobile menu drawer when clicking outside it.
    if (!event.target.closest('[data-header-drawer]')) {
      document.querySelectorAll('[data-header-drawer][open]').forEach((drawer) => {
        drawer.removeAttribute('open');
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-header-disclosure][open]').forEach((disclosure) => {
      disclosure.removeAttribute('open');
    });
    document.querySelectorAll('[data-header-search][open]').forEach((search) => {
      search.removeAttribute('open');
    });
    // Escape closes the menu drawer no matter where focus is — the panel's
    // own keydown handler only fires while focus is inside it.
    document.querySelectorAll('[data-header-drawer][open]').forEach((drawer) => {
      drawer.removeAttribute('open');
    });
  });

  initHeaderElements();
  document.addEventListener('shopify:section:load', initHeaderElements);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Section javascript blocks are concatenated into a shared scripts.js, so
  // document.currentScript never points inside a section. Initialize every
  // hero section on the page instead, with a per-element guard.
  const initHeroSection = (section) => {
    if (section.dataset.heroReady === 'true') return;
    section.dataset.heroReady = 'true';

    const slides = Array.from(section.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
    const prevButton = section.querySelector('[data-hero-prev]');
    const nextButton = section.querySelector('[data-hero-next]');
    const autoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 5000;
    const parallaxEnabled = section.dataset.parallax === 'true';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mediaItems = Array.from(section.querySelectorAll('[data-hero-media]'));
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let autoplayTimer = null;

    if (activeIndex < 0) activeIndex = 0;

    const updateSlides = (index) => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      activeIndex = index;
    };

    const goToSlide = (index) => {
      const normalizedIndex = (index + slides.length) % slides.length;
      updateSlides(normalizedIndex);
    };

    const startAutoplay = () => {
      if (!autoplay || prefersReducedMotion || slides.length < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(() => {
        goToSlide(activeIndex + 1);
      }, autoplaySpeed);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
    };

    prevButton?.addEventListener('click', () => {
      goToSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      goToSlide(activeIndex + 1);
      startAutoplay();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    // Pause while keyboard focus is inside the slider (WCAG 2.2.2) and when
    // the tab is hidden — no point rotating slides nobody can see.
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', (event) => {
      if (!section.contains(event.relatedTarget)) startAutoplay();
    });
    document.addEventListener('visibilitychange', () => {
      document.hidden ? stopAutoplay() : startAutoplay();
    });

    if (parallaxEnabled && !prefersReducedMotion) {
      let ticking = false;
      // The setting's info text promises parallax is disabled on mobile.
      const desktopQuery = window.matchMedia('(min-width: 750px)');

      const updateParallax = () => {
        if (!desktopQuery.matches) {
          mediaItems.forEach((media) => {
            media.style.transform = '';
          });
          ticking = false;
          return;
        }
        const rect = section.getBoundingClientRect();
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const translateY = (progress - 0.5) * 40;

        mediaItems.forEach((media) => {
          media.style.transform = `translate3d(0, ${translateY}px, 0) scale(1.08)`;
        });

        ticking = false;
      };

      const requestParallaxUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      document.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
    }

    updateSlides(activeIndex);
    startAutoplay();
  };

  const initAllHeroSections = () => {
    document.querySelectorAll('.hero-section').forEach(initHeroSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroSections);
  } else {
    initAllHeroSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.hero-section');
    if (section) initHeroSection(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var STORAGE_PREFIX = 'newsletter-popup:';

    function readState(key) {
      try {
        var raw = localStorage.getItem(STORAGE_PREFIX + key);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (data.until && Date.now() > data.until) {
          localStorage.removeItem(STORAGE_PREFIX + key);
          return null;
        }
        return data;
      } catch (e) {
        return null;
      }
    }

    function writeState(key, days) {
      try {
        localStorage.setItem(
          STORAGE_PREFIX + key,
          JSON.stringify({ until: Date.now() + days * 24 * 60 * 60 * 1000 })
        );
      } catch (e) {
        /* storage unavailable */
      }
    }

    function initPopup(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var sectionId = root.dataset.sectionId;
      var dialog = root.querySelector('[role="dialog"]');
      var closers = root.querySelectorAll('[data-newsletter-popup-close]');
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var delay = parseInt(root.dataset.delay, 10) || 0;
      var exitIntent = root.dataset.exitIntent === 'true';
      var scrollTrigger = parseInt(root.dataset.scrollTrigger, 10) || 0;
      var dismissDays = parseInt(root.dataset.dismissDays, 10) || 7;
      var subscribedDays = parseInt(root.dataset.subscribedDays, 10) || 365;
      var posted = !!root.querySelector('[data-newsletter-popup-posted]');

      var isOpen = false;
      var lastFocused = null;
      var timer = null;
      var armed = false;

      function focusableElements() {
        return Array.prototype.filter.call(
          dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'),
          function (el) { return el.offsetParent !== null; }
        );
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusableElements();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function open() {
        if (isOpen) return;
        isOpen = true;
        lastFocused = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('newsletter-popup-open');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeydown);
        var input = dialog.querySelector('input[type="email"]');
        window.requestAnimationFrame(function () {
          (input || dialog).focus({ preventScroll: true });
        });
        disarm();
      }

      function close(remember) {
        if (!isOpen) return;
        isOpen = false;
        root.hidden = true;
        document.documentElement.classList.remove('newsletter-popup-open');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
        if (remember !== false && !designMode) {
          writeState('dismissed', dismissDays);
        }
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus({ preventScroll: true });
        }
      }

      function onMouseLeave(event) {
        if (event.clientY <= 0) open();
      }

      function onScroll() {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if ((window.scrollY / max) * 100 >= scrollTrigger) open();
      }

      function arm() {
        if (armed) return;
        armed = true;
        if (scrollTrigger > 0) {
          window.addEventListener('scroll', onScroll, { passive: true });
        } else {
          timer = window.setTimeout(open, delay * 1000);
        }
        if (exitIntent && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          document.addEventListener('mouseleave', onMouseLeave);
        }
      }

      function disarm() {
        armed = false;
        if (timer) window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('mouseleave', onMouseLeave);
      }

      Array.prototype.forEach.call(closers, function (el) {
        el.addEventListener('click', function () { close(); });
      });

      root._newsletterPopup = { open: open, close: close, disarm: disarm };

      if (posted) {
        // Shopify redirected back after a successful signup: show the confirmation.
        writeState('subscribed', subscribedDays);
        open();
        return;
      }

      if (designMode) {
        // In the theme editor, only open when the merchant selects the section.
        return;
      }

      if (readState('subscribed') || readState('dismissed')) return;

      // Don't fight the cart drawer or other overlays on initial load.
      arm();
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-newsletter-popup]'), initPopup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initPopup(event.target.querySelector('[data-newsletter-popup]'));
    });

    document.addEventListener('shopify:section:select', function (event) {
      var root = event.target.querySelector('[data-newsletter-popup]');
      if (root && root._newsletterPopup) root._newsletterPopup.open();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      var root = event.target.querySelector('[data-newsletter-popup]');
      if (root && root._newsletterPopup) root._newsletterPopup.close(false);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-newsletter-popup]');
      if (root && root._newsletterPopup) {
        root._newsletterPopup.disarm();
        root._newsletterPopup.close(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-funnel"] && !Shopify.designMode) return;
  try {
    
  const initQuizFunnel = (root) => {
    if (root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    const questions = [...root.querySelectorAll('[data-quiz-question]')];
    const results = [...root.querySelectorAll('[data-quiz-result]')];
    const intro = root.querySelector('[data-quiz-intro]');
    const emailStep = root.querySelector('[data-quiz-email]');
    const progress = root.querySelector('[data-quiz-progress]');
    const progressFill = root.querySelector('[data-quiz-progress-fill]');
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const progressTemplate = progressLabel?.dataset.progressTemplate || '[[current]] / [[total]]';
    const storageKey = `yc-quiz-${root.dataset.quizId || ''}`;
    const answers = [];

    if (!questions.length || !results.length) return;

    const allSteps = [intro, ...questions, emailStep, ...results].filter(Boolean);

    const showStep = (step, { focus = true } = {}) => {
      allSteps.forEach((node) => {
        node.hidden = node !== step;
        node.classList.toggle('is-active', node === step);
      });

      const isQuestion = step.hasAttribute('data-quiz-question');
      if (progress) {
        progress.hidden = !isQuestion;
        if (isQuestion) {
          const index = Number(step.dataset.questionIndex) + 1;
          if (progressFill) progressFill.style.width = `${Math.round((index / questions.length) * 100)}%`;
          if (progressLabel) {
            progressLabel.textContent = progressTemplate
              .replace('[[current]]', String(index))
              .replace('[[total]]', String(questions.length));
          }
        }
      }

      if (focus) step.querySelector('[data-quiz-step-heading]')?.focus({ preventScroll: false });
    };

    const computeResult = () => {
      // Winner = most frequent key; ties resolve to the first key that hit
      // the winning count (stable, order-of-answers based).
      const counts = new Map();
      let winner = null;
      let winnerCount = 0;
      answers.forEach((key) => {
        const next = (counts.get(key) || 0) + 1;
        counts.set(key, next);
        if (next > winnerCount) {
          winner = key;
          winnerCount = next;
        }
      });
      return results.find((node) => node.dataset.resultKey === winner) || results[0];
    };

    const finish = () => {
      const resultNode = computeResult();
      if (emailStep) {
        // Remember the pending result key — the customer form reloads the
        // page, and the restore below jumps straight to the result.
        try {
          sessionStorage.setItem(storageKey, resultNode.dataset.resultKey || '');
        } catch (storageError) {
          // Storage blocked — the skip link still reveals the result live.
        }
        showStep(emailStep);
      } else {
        showStep(resultNode);
      }
    };

    const revealStoredResult = () => {
      let key = '';
      try {
        key = sessionStorage.getItem(storageKey) || '';
        sessionStorage.removeItem(storageKey);
      } catch (storageError) {
        return false;
      }
      if (!key) return false;
      const stored = results.find((node) => node.dataset.resultKey === key);
      if (!stored) return false;
      showStep(stored, { focus: false });
      return true;
    };

    root.querySelector('[data-quiz-start]')?.addEventListener('click', () => showStep(questions[0]));

    questions.forEach((question, index) => {
      question.querySelectorAll('[data-quiz-answer]').forEach((answer) => {
        answer.addEventListener('click', () => {
          question
            .querySelectorAll('[data-quiz-answer]')
            .forEach((node) => node.classList.toggle('is-selected', node === answer));
          answers[index] = answer.dataset.resultKey || 'a';

          // Brief pause so the selection state is visible before advancing.
          window.setTimeout(() => {
            if (index + 1 < questions.length) {
              showStep(questions[index + 1]);
            } else {
              finish();
            }
          }, 220);
        });
      });

      question.querySelector('[data-quiz-back]')?.addEventListener('click', () => {
        showStep(index === 0 ? intro || questions[0] : questions[index - 1]);
      });
    });

    emailStep?.querySelector('[data-quiz-skip-email]')?.addEventListener('click', () => {
      try {
        sessionStorage.removeItem(storageKey);
      } catch (storageError) {
        // Ignore.
      }
      showStep(computeResult());
    });

    root.querySelectorAll('[data-quiz-restart]').forEach((button) => {
      button.addEventListener('click', () => {
        answers.length = 0;
        root.querySelectorAll('[data-quiz-answer]').forEach((node) => node.classList.remove('is-selected'));
        showStep(intro || questions[0]);
      });
    });

    // Returning from the email form submit (?customer_posted=true) — show
    // the result that was pending before the reload.
    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      revealStoredResult();
    }
  };

  document.querySelectorAll('[data-quiz]').forEach(initQuizFunnel);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-quiz]').forEach(initQuizFunnel);
  });

  // Theme editor: clicking a question/result block in the sidebar shows
  // that step so merchants can style what they're editing.
  document.addEventListener('shopify:block:select', (event) => {
    const step = event.target.closest?.('[data-quiz-question], [data-quiz-result]');
    const root = event.target.closest?.('[data-quiz]');
    if (!step || !root) return;
    [...root.querySelectorAll('[data-quiz-intro], [data-quiz-question], [data-quiz-email], [data-quiz-result]')].forEach(
      (node) => {
        node.hidden = node !== step;
      }
    );
    const progress = root.querySelector('[data-quiz-progress]');
    if (progress) progress.hidden = !step.hasAttribute('data-quiz-question');
  });

  } catch(e) { console.error(e); }
})();
})();
